export default __webpack_public_path__ + "static/media/WF2.e2ecd392.png";